console.log('scripts.js loaded');

jQuery(document).ready(function($){

	jQuery('.home-slider-wrapper .home-slider').slick({
		slidesToShow: 3.5,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		infinite: false,

		prevArrow: '<button type="button" class="slick-prev">Previous</button>',
		nextArrow: '<button type="button" class="slick-next">Next</button>',

		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 2.25,
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2.15,
				}
			},
			{
				breakpoint: 992, //
				settings: {
					slidesToShow: 1.15,
				}
			}
		]

	}).on('afterChange', function(event, slick, currentSlide){
        var lastSlide = slick.slideCount - slick.options.slidesToShow;

        if (currentSlide >= lastSlide) {
            $('.home-slider-wrapper').addClass('last-slide');
        } else {
            $('.home-slider-wrapper').removeClass('last-slide');
        }
    });

	const enrollModalEl = new bootstrap.Modal('#enrollModal', {});
	const loginModalEl = new bootstrap.Modal('#loginModal', {});
	const facultyModalEl = new bootstrap.Modal('#facultyModal', {});

	$('body').on('click','div.faculty-modal-trigger',function(e){
		let el = $(this);
		let modalTitle = $('#facultyModalLabel');
		let modalSubTitle = $('#facultyModalRole');
		let modalBody = $('#facultyModalBody');
		let modalDataName = el.data('modal-info-name');
		let modalDataRole = el.data('modal-info-role');
		let modalDataBody = el.data('modal-info-body');
		modalTitle.text(modalDataName);
		modalSubTitle.text(modalDataRole);
		modalBody.html(modalDataBody);
		facultyModalEl.show();
	});


	//Enroll modal link
	$('body').on('click','#enrollment-intro a',function(e){
		enrollModalEl.hide();
		loginModalEl.show();
	});
	//Enroll button link
	$('body').on('click','a[data-login="open"]',function(e){
		enrollModalEl.hide();
		loginModalEl.show();
	});
	//Login modal link
	$('body').on('click','#login-intro a',function(e){
		loginModalEl.hide();
		enrollModalEl.show();
	});
	//Enroll button with data attribute
	$('body').on('click','a[data-enroll="open"]',function(e){
		e.preventDefault();
		enrollModalEl.show();
	});

	if ( $('#trailerModal').length > 0 ) {
		const trailerModalEl = new bootstrap.Modal('#trailerModal', {});
		$('body').on('click','div[data-trailer="open"]',function(e){
			e.preventDefault();
			trailerModalEl.show();
		});

		$('#trailerModal').on("hidden.bs.modal", function () {
			let video = $('#trailerModal iframe').attr("src");
			$('#trailerModal iframe').attr("src","");
			$('#trailerModal iframe').attr("src",video);
			//$('#trailerModal iframe').get(0).stopVideo();
		});
	}

	//Show modal on load if hash is present
	if (window.location.hash == '#enroll' || window.location.hash == '#mepr_jump') {
		enrollModalEl.show();
	}



	$('.secondary-menu').on('click','li.menu-item-has-children > a',function(e){
		if(window.innerWidth <= 992){
			e.preventDefault();
			if($(this).hasClass('active')){
				$(this).removeClass('active');
			}
			else{
				$(this).addClass('active');
			}
		}
	});

	function validateEmail(email) {
		var re = /\S+@\S+\.\S+/;
		return re.test(email);
	}

	$(document).on('submit','form.newsletter-form',function(e){
		e.preventDefault;

		let formValidation = false;
		let formParent = $(this).parent();
		let formLoader = formParent.find('div.newsletter-loader').eq(0);
		let formError = formParent.find('div.newsletter-error').eq(0);
		let formSuccessDiv = formParent.find('div.successful-subscription').eq(0);

		formLoader.addClass('show');
		formError.removeClass('show');

		let firstName =  $(this).find('input[name="first-name"]').eq(0).val();
		let lastName = $(this).find('input[name="last-name"]').eq(0).val();
		let email = $(this).find('input[name="email-address"]').eq(0).val();
		let nonce = 'nonce';

		if( firstName && lastName && validateEmail(email) ){
			formValidation = true;
		}
		else{
			formError.addClass('show');
			formLoader.removeClass('show');
		}

		if(formValidation) {
			//Perform ajax
			jQuery.ajax({
				type: "post",
				dataType: "json",
				url: ajax.ajaxurl,
				data: {
					action: "klaviyo_newsletter_subscribe",
					firstName: firstName,
					lastName: lastName,
					email: email,
					nonce: nonce
				},
				success: function (response) {
					if (response.type == "success") {
						formLoader.removeClass('show');
						formSuccessDiv.addClass('success');
					} else {
						formLoader.addClass('show');
					}
				}
			});
		}
		return  false;
	});


    $(".dropdown-toggle").on("click", function () {
        $(".collapse.show").removeClass("show");
    });

    // Add testimonial slider initialization here
    if ($('.testimonial-slider').length) {
        $('.testimonial-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            // Fade out current text
            $('.testimonial-text[data-slide="' + currentSlide + '"]').removeClass('active');
        }).on('afterChange', function(event, slick, currentSlide) {
            // Fade in new text after slide completes
            setTimeout(function() {
                $('.testimonial-text[data-slide="' + currentSlide + '"]').addClass('active');
            }, 100); // Small delay to ensure smooth transition
        }).slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1500, // Match our CSS transition duration
            slidesToShow: 1,
            cssEase: 'ease',
            prevArrow: '<button type="button" class="slick-prev">Previous</button>',
            nextArrow: '<button type="button" class="slick-next">Next</button>'
        });

        // Activate first slide's text
        $('.testimonial-text[data-slide="0"]').addClass('active');
    }

	if (window.matchMedia('(max-width: 991px)').matches) {
		const imageWrappers = document.querySelectorAll('.image-fade-columns .image-wrapper');

		imageWrappers.forEach(wrapper => {
		  wrapper.addEventListener('click', function() {
			// Remove active class from all other wrappers
			imageWrappers.forEach(w => {
			  if (w !== wrapper) w.classList.remove('active');
			});
			// Toggle active class on clicked wrapper
			this.classList.toggle('active');
		  });
		});
	  }


	  console.log('Scripts loaded, adding topic-select handler');

	  const topicSelect = $('#topic-select');
	  if (topicSelect.length) {
		  loadPosts(topicSelect.val(), 1, topicSelect[0]);
	  }

    // Update existing topic-select handler and add pagination handler
    $('body').on('change', '#topic-select', function(e){
        e.preventDefault();
        const topicId = $(this).val();
        const permalink = $(this).data('permalink');
        const container = $(this).closest('.sidebar-and-article-archive-block');
        const postsContainer = container.find('.posts-container');
        const paginationContainer = container.find('.container .pagination-block');  // Update selector

        // Show loading state
        postsContainer.addClass('loading');

        fetch(`/wp-json/tikvah/v1/filter-posts?topic=${topicId}&post_type=resource-library&paged=1`)
            .then(response => response.json())
            .then(data => {
                console.log('Response data:', data);  // Debug response
                if (data.success) {
                    postsContainer.html(data.data.posts);
                    if (data.data.pagination) {
                        paginationContainer.html(data.data.pagination);
                    }

                    // Update URL without reload
                    if (history.pushState) {
                        const newurl = topicId ?
                            permalink + '?topic=' + topicId :
                            permalink;
                        window.history.pushState({path: newurl}, '', newurl);
                    }
                }
            })
            .catch(error => console.error('Error:', error))
            .finally(() => {
                postsContainer.removeClass('loading');
            });
    });

    // Add pagination handler
    $('body').on('click', '.pagination a', function(e) {
        e.preventDefault();
        const topicId = $('#topic-select').val();
        const page = $(this).attr('href').match(/page\/(\d+)/);
        if (page) {
            loadPosts(topicId, page[1], this);
        }
    });

    // Helper function to load posts
    function loadPosts(topicId, page, triggerElement) {
        const permalink = $('#topic-select').data('permalink');
        const section = $(triggerElement).closest('.sidebar-and-article-archive-block');
        const postsContainer = section.find('.posts-container');
        const paginationContainer = section.find('.pagination');

        // Show loading state
        section.addClass('loading');

        fetch(`/wp-json/tikvah/v1/filter-posts?topic=${topicId}&post_type=resource-library&paged=${page}`)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    postsContainer.html(data.data.posts);
                    paginationContainer.html(data.data.pagination);

                    // Update URL without reload
                    if (history.pushState) {
                        let newurl = permalink;
                        if (topicId) {
                            newurl += `?topic=${topicId}`;
                            if (page > 1) {
                                newurl += `&paged=${page}`;
                            }
                        } else if (page > 1) {
                            newurl += `?paged=${page}`;
                        }
                        window.history.pushState({path: newurl}, '', newurl);
                    }

                    // Scroll to top of posts container
                    $('html, body').animate({
                        scrollTop: postsContainer.offset().top - 100
                    }, 500);
                }
            })
            .catch(error => console.error('Error:', error))
            .finally(() => {
                section.removeClass('loading');
            });
    }


	$( '.navbar-toggler' ).on( 'click', function() {
		if( $( 'body' ).hasClass( 'noscroll' ) ) {
			$(this).attr( 'aria-expanded', 'false' );
			$( 'body' ).removeClass( 'noscroll' );
		} else {
			$(this).attr( 'aria-expanded', 'true' );
			$( 'body' ).addClass( 'noscroll' );
		}
	});


});

function emailCurrentPage(){
	window.location.href="mailto:?subject="+document.title+"&body="+escape(window.location.href);
}

// const mainNav = document.getElementById('navbar-full-menu');
// mainNav.addEventListener('hidden.bs.collapse', event => {
// 	jQuery('body').removeClass('noscroll');
// })
// mainNav.addEventListener('show.bs.collapse', event => {
// 	jQuery('body').addClass('noscroll');
// })


var acc = document.getElementsByClassName("sidebar-menu-trigger");
var i;

for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function() {
		this.classList.toggle("active");
		var panel = this.nextElementSibling;
		if (panel.style.maxHeight) {
			panel.style.maxHeight = null;
		} else {
			panel.style.maxHeight = panel.scrollHeight + "px";
		}
	});
}

function mobileLink( url, external = false ){
	if(window.innerWidth <= 767 || external){
		if(url){
			window.open(url, '_blank');
		}
	} else {
		window.location.href = url;
	}
}


var sliderCount = document.querySelectorAll('.home-slider-thumbnails .swiper-slide').length;

var swiper = new Swiper(".home-slider-thumbnails", {
	loop: window.innerWidth <= 1400,
	slidesPerView: 1,
	freeMode: false,
	watchSlidesProgress: false,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	breakpoints: {
		320: {
			slidesPerView: 1,
			centeredSlides: false,
		},
		768: {
			slidesPerView: sliderCount,
			spaceBetween: 30
		},
		900: {
			slidesPerView: sliderCount,
			spaceBetween: 40
		},
		1400: {
			slidesPerView: sliderCount,
			spaceBetween: 40
		}
	}

});

var swiper2 = new Swiper(".home-slider", {
	loop: true,
    spaceBetween: 10,
    slidesPerView: 1,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	thumbs: {
		swiper: swiper,
    },
});





window.addEventListener('scroll', function (event) {

    var headerContainer = document.querySelector('.header-container');
    var header = document.querySelector('.secondary-menu-container');
    var menu = document.querySelector('.secondary-menu');
	var dynamic_blocks = document.querySelector('.dynamic-blocks');
	var wysiwyg = document.querySelector('.page-template-default > .container-xl');
	var featured_post_image = document.querySelector('.featured-post-image');
    var wysiwyg_row = document.querySelector('.page-template-default > .container-xl .row');
    if (!wysiwyg_row) {
        return;
    }

    var is_empty_wysiwyg = (wysiwyg_row.innerHTML.trim().length > 0);
    if (headerContainer && header && menu) {
        var sticky = header.offsetTop;
        if (Number(window.scrollY) > Number(sticky)) {
            headerContainer.classList.add("sticky");
            header.classList.add("sticky");
            menu.classList.add("sticky");
            header.style.top = headerContainer.offsetHeight + "px";
            menu.style.top = (header.offsetHeight + headerContainer.offsetHeight) + "px";
			if(featured_post_image){
				featured_post_image.style.marginTop = original_header_height + "px";
			}else if(is_empty_wysiwyg){
				wysiwyg.style.marginTop = original_header_height + "px";
			}else{
				dynamic_blocks.style.marginTop = original_header_height + "px";
			}
        } else if((Number(window.scrollY) < Number(sticky)) || (Number(window.scrollY) - 100 < Number(sticky) * 24)) {
			if(featured_post_image){
				featured_post_image.style.marginTop = "0px";
			}else if(is_empty_wysiwyg){
				wysiwyg.style.marginTop = "0px";
			}else{
				dynamic_blocks.style.marginTop = "0px";
			}
            headerContainer.classList.remove("sticky");
            header.classList.remove("sticky");
            menu.classList.remove("sticky");
            header.style.top = "0";
            menu.style.top = "0";
        }
    }
});

if(window.onscroll === document.body.onscroll){
    var headerContainer = document.querySelector('.header-container');
    var header = document.querySelector('.secondary-menu-container');
    var menu = document.querySelector('.secondary-menu');
	var dynamic_blocks = document.querySelector('.dynamic-blocks');
	var featured_post_image = document.querySelector('.featured-post-image');
	var wysiwyg = document.querySelector('.page-template-default > .container-xl');
    var wysiwyg_row = document.querySelector('.page-template-default > .container-xl .row');
    if (wysiwyg_row) {
        var is_empty_wysiwyg = (wysiwyg_row.innerHTML.trim().length > 0);

		var original_header_height = (header.offsetHeight + headerContainer.offsetHeight);
		if ( menu ) {
			original_header_height = (original_header_height + menu.offsetHeight);
		}

        if (window.screen.width <= 390) {
            original_header_height = String(Number(original_header_height) - 82);
        } else if (window.screen.width <= 414) {
            original_header_height = String(Number(original_header_height) - 63);
        } else {
            original_header_height = String(Number(original_header_height) - 44);
        }
        if (headerContainer && header && menu) {
            var sticky = original_header_height;
            if (window.scrollY > sticky) {
                menu.style.top = (header.offsetHeight + headerContainer.offsetHeight) + "px";
                if (featured_post_image) {
                    featured_post_image.style.marginTop = original_header_height + "px";
                } else if (is_empty_wysiwyg) {
                    wysiwyg.style.marginTop = original_header_height + "px";
                } else {
                    dynamic_blocks.style.marginTop = original_header_height + "px";
                }
            } else {
                if (featured_post_image) {
                    featured_post_image.style.marginTop = "0px";
                } else if (is_empty_wysiwyg) {
                    wysiwyg.style.marginTop = "0px";
                } else {
                    dynamic_blocks.style.marginTop = "0px";
                }
            }
        }
    }

}
document.body.onscroll = null;

// (function($) {
// 	"use strict";
//
// 	jQuery(function($) {
// 		const swiper = new Swiper('.swiper-toa', {
// 			// Optional parameters
//             centerInsufficientSlides: true,
// 			loop: false,
// 			slidesPerView: 1,
// 			autoplay: {
// 				delay: 2500,
// 				disableOnInteraction: true,
// 			},
// 			// Navigation arrows
// 			navigation: {
// 				nextEl: '.swiper-button-next',
// 				prevEl: '.swiper-button-prev',
// 			},
// 			breakpoints: {
// 				768: {
// 					slidesPerView: 2,
// 					spaceBetween: 40,
// 				},
// 				992: {
// 					slidesPerView: 4,
// 					spaceBetween: 40,
// 				},
// 			},
// 		});
//
// 	});
//
// 	$(".read-more-open-link").click(function(){
// 		$(this).parent().css("height","auto");
// 		$(this).parent().css("overflow","visible");
// 		$(this).parent().find('.fade-out').hide();
// 		$(this).parent().find('.read-less-close-link').show();
// 		$(this).hide();
// 	});
//
// 	$(".read-less-close-link").click(function(){
// 		$(this).parent().css("height","250px");
// 		$(this).parent().css("overflow","hidden");
// 		$(this).parent().find('.fade-out').show();
// 		$(this).parent().find('.read-more-open-link').show();
// 		$(this).hide();
// 	});
//
// 	$(".custom-read-more-open-link").click(function(){
// 		$(this).parent().css("height","auto");
// 		$(this).parent().css("overflow","visible");
// 		$(this).parent().find('.fade-out').hide();
// 		$(this).parent().find('.custom-read-less-close-link').show();
// 		$(this).hide();
// 	});
//
// 	$(".custom-read-less-close-link").click(function(){
// 		$(this).parent().css("height","120px");
// 		$(this).parent().css("overflow","hidden");
// 		$(this).parent().find('.fade-out').show();
// 		$(this).parent().find('.custom-read-more-open-link').show();
// 		$(this).hide();
// 	});
//
// 	$(".tikvah-live-podcast-feed .read-more-open-link").click(function(){
// 		$(this).parent().css("height","auto");
// 		$(this).parent().css("overflow","visible");
// 		$(this).parent().css("margin-bottom","70px");
// 		$(this).parent().find('.fade-out').hide();
// 		$(this).parent().find('.read-less-close-link').show();
// 		$(this).hide();
// 	});
//
// 	$(".tikvah-live-podcast-feed .read-less-close-link").click(function(){
// 		$(this).parent().css("height","250px");
// 		$(this).parent().css("overflow","hidden");
// 		$(this).parent().css("margin-bottom","20px");
// 		$(this).parent().find('.fade-out').show();
// 		$(this).parent().find('.read-more-open-link').show();
// 		$(this).hide();
// 	});
//
// 	$(" .course-instructors .read-more-open-link").click(function(){
// 		$(this).parent().css("height","auto");
// 		$(this).parent().css("overflow","visible");
// 		$(this).parent().css("margin-bottom","70px");
// 		$(this).parent().find('.fade-out').hide();
// 		$(this).parent().find('.read-less-close-link').show();
// 		$(this).hide();
// 	});
//
// 	$(".course-instructors .read-less-close-link").click(function(){
// 		$(this).parent().css("height","200px");
// 		$(this).parent().css("overflow","hidden");
// 		$(this).parent().css("margin-bottom","20px");
// 		$(this).parent().find('.fade-out').show();
// 		$(this).parent().find('.read-more-open-link').show();
// 		$(this).hide();
// 	});
//
//
//
// 	// Tikvah Online Academy Checkout Process
// 	//===========================================
	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
//
// 	function getUrlVars() {
// 		var vars = {};
// 		var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
// 			vars[key] = value;
// 		});
// 		return vars;
// 	}
//

//
// 	//  TSP 2023 Open House Modal
// 	$(document).ready(function(){
// 		if($('body').hasClass('parent-pageid-21363')) {
// 			if(!$('body').hasClass('page-id-31283')) {
// 				var modalSeen = getCookie("open-house-modal-seen");
// 				if (!modalSeen) {
// 					$('#open-house-modal').css('display', 'block');
// 					setCookie('open-house-modal-seen', 'true', 1);
// 				}
// 			}
// 		}
// 	});
//
// 	// Nominate Scholar Modal
// 	/*$(document).ready(function(){
// 		var modalSeen = false; //getCookie("open-house-modal-seen");
// 		if ($('.page-id-55358').length > 0) {
// 			$('#nominate-scholar-modal').css('display', 'block');
// 			//setCookie('open-house-modal-seen', 'true', 1);
// 		}
// 	});*/
//
// jQuery(function ($) {
// 	$(".add-curriculum").click(function () {
// 		var id = $(this).data('course-id');
// 		var post_id = $(this).data('post-id');
// 		var counter = $('#course-counter');
// 		var panelbody = $('#checkout-panel-body');
// 		var panel = $('#checkout-panel');
//
// 		if ($(this).hasClass('selected-course')) {
// 			// User is removing this course
// 			var courses = getCookie("tikvah-online-cart");
//
// 			$('.enabled-checkout a').each(function () {
// 				var link = $(this).attr('href');
// 				var new_link = link.replace("TOA" + id + ";", "");
// 				$(this).attr('href', new_link)
// 			})
//
// 			let toa_id = "TOA" + id + ";";
//
// 			$('.enabled-checkout a').attr('href').replace(toa_id, "")
//
// 			if (courses) {
// 				console.log(post_id);
// 				console.log(courses);
// 				courses = JSON.parse(courses);
// 				if (courses.includes(post_id)) {
// 					console.log('splicing');
// 					courses.splice(courses.indexOf(post_id), 1);
// 					console.log(courses);
// 				}
//
//
// 				if (courses.length === 0) {
// 					$('.enabled-checkout').each(function (index) {
// 						$(this).hide();
// 					});
// 					$('.disabled-checkout').each(function (index) {
// 						$(this).show();
// 					});
// 				}
//
// 				courses = JSON.stringify(courses);
// 				console.log(courses);
// 				setCookie("tikvah-online-cart", courses, 3)
// 			}
//
// 			$(this).removeClass('selected-course');
// 			counter.html(parseFloat(counter.html()) - 1);
//
// 			$('#panel-course-' + post_id).remove();
// 			setCookie("course" + id, 'false', 3);
//
// 		} else {
// 			// User is selecting course
// 			setCookie("course" + id, 'true', 3);
//
// 			$('.enabled-checkout a').each(function () {
// 				this.href += "TOA" + id + ";";
// 			})
//
// 			if (getCookie("course" + id)) {
//
// 				$(this).addClass('selected-course');
//
// 				var nesting = $(this);
// 				nesting.prop("disabled", true);
// 				counter.html(parseFloat(counter.html()) + 1);
//
// 				var courses = getCookie("tikvah-online-cart");
// 				var course_array;
//
// 				if (courses) {
// 					console.log('already had courses');
// 					console.log(courses);
// 					courses = JSON.parse(courses);
// 					if (!courses.includes(post_id)) {
// 						courses.push(post_id);
// 					}
// 					course_array = courses;
// 					courses = JSON.stringify(courses);
// 					console.log(courses);
// 					setCookie("tikvah-online-cart", courses, 3)
// 				} else {
// 					console.log('first course');
// 					courses = [];
// 					courses.push(post_id);
// 					course_array = courses;
// 					courses = JSON.stringify(courses);
// 					setCookie("tikvah-online-cart", courses, 3)
// 					panel.removeClass('hidden-panel');
// 				}
//
// 				$('.enabled-checkout').each(function (index) {
// 					$(this).show();
// 				});
// 				$('.disabled-checkout').each(function (index) {
// 					$(this).hide();
// 				});
//
// 				var course_query = '';
// 				course_array.forEach(function (item, index) {
// 					course_query += 'courses[]=' + item;
//
// 					if (index !== course_array.length) {
// 						course_query += '&';
// 					}
// 				});
//
// 				$.ajax({
// 					method: "GET",
// 					url: "/wp-content/themes/tikvahcenter/2019/load-cart.php?courses[]=" + post_id
// 				})
// 					.done(function (html) {
// 						//console.log('success!');
// 						//console.log('this is the html: ' + html);
// 						panelbody.append(html);
// 						nesting.prop("disabled", false);
// 					});
// 			} else {
// 				$('#adblock-modal').css('display', 'block');
// 			}
// 		}
// 	});
//
// 	function deleteCourseFromCart() {
// 		console.log('removing course');
// 		var post_id = $(this).data('post-id');
// 		var counter = $('#course-counter');
// 		var panelbody = $('#checkout-panel-body');
// 		var panel = $('#checkout-panel');
//
// 		// User is removing this course
// 		var courses = getCookie("tikvah-online-cart");
//
// 		if (courses) {
// 			courses = JSON.parse(courses);
// 			if (courses.includes(post_id)) {
// 				courses.splice(courses.indexOf(post_id), 1);
// 			}
//
// 			if (courses.length === 0) {
// 				$('.enabled-checkout').each(function( index ) {
// 					$(this).hide();
// 				});
// 				$('.disabled-checkout').each(function( index ) {
// 					$(this).show();
// 				});
// 			}
//
// 			courses = JSON.stringify(courses);
// 			setCookie("tikvah-online-cart", courses, 3);
// 		}
//
// 		//$(this).parent().remove();
// 		counter.html(parseFloat(counter.html()) - 1);
//
// 		$('#panel-course-' + post_id).remove();
// 		setCookie("course" + id, 'false', 3);
// 	}
//
//
// 	$(".checkout-panel-toggle").click(function(){
// 		var panel = $(this).parent().parent();
// 		panel.css('height', '');
// 		panel.css('height', null);
//
// 		if (panel.hasClass('collapsed')) {
//
// 			// Clone and hide element to get height for transition
// 			var clonedPanel = panel.clone(true);
// 			clonedPanel.css('height', 'auto').css('display', 'none');
// 			$(document.body).append(clonedPanel);
//
// 			panel.css('height', clonedPanel.height());
// 			clonedPanel.remove();
// 			panel.removeClass('collapsed');
// 			$(this).html('<span>Minimize</span> <i class="fas fa-angle-down"></i>')
// 		} else {
// 			panel.addClass('collapsed');
// 			$(this).html('<span>Maximize</span> <i class="fas fa-angle-up"></i>')
// 		}
//
// 		panel.css('height', '');
// 		panel.css('height', null);
// 	});
//
// 	if ( $('#checkout-panel').length > 0 ) {
// 		var counter = $('#course-counter');
// 		var courses = getCookie("tikvah-online-cart");
// 		var panel = $('#checkout-panel');
// 		var panelbody = $('#checkout-panel-body');
//
// 		if (courses) {
// 			courses = JSON.parse(courses);
//
// 			$('.add-curriculum').each(function( index ) {
// 				console.log(courses);
// 				var id = $(this).data('course-id');
// 				var post_id = $(this).data('post-id');
// 				console.log(post_id);
// 				if (courses.includes(post_id)) {
// 					$(this).addClass('selected-course');
// 				}
// 			});
//
// 			panel.removeClass('hidden-panel');
//
// 			if (courses.length !== 0) {
// 				$('.enabled-checkout').each(function( index ) {
// 					$(this).show();
// 				});
// 				$('.disabled-checkout').each(function( index ) {
// 					$(this).hide();
// 				});
// 			}
//
// 			counter.html(courses.length)
//
// 			var course_query = '';
// 			courses.forEach(function (item, index) {
// 				course_query += 'courses[]=' + item;
//
// 				if (index !== courses.length) {
// 					course_query += '&';
// 				}
// 			});
//
// 			$.ajax({
// 				method: "GET",
// 				url: "/wp-content/themes/tikvahcenter/2019/load-cart.php?" + course_query
// 			})
// 				.done(function( html ) {
// 					panelbody.append(html);
// 				});
// 		}
// 	}
// });


//
// 	if ( $('body').hasClass('page-template-page-tikvah-online-summer-forum') || $('body').hasClass('single-tikvah-online') || $('body').hasClass('page-template-page-toa-main') ) {
// 		var counterOpen = $('#course-counter-open');
// 		var coursesOpen = getCookie("tikvah-online-cart-open");
// 		var utmOpen = getUrlVars();
// 		var panelOpen = $('#checkout-panel-open');
// 		var panelbodyOpen = $('#checkout-panel-body-open');
//
// 		if (coursesOpen) {
// 			coursesOpen = JSON.parse(coursesOpen);
//
// 			$('.add-curriculum-open').each(function( index ) {
// 				var id = $(this).data('course-id');
// 				var post_id = $(this).data('post-id');
// 				console.log(coursesOpen);
// 				if (coursesOpen.includes(post_id)) {
// 					$(this).addClass('selected-course');
// 				}
// 			});
//
// 			panelOpen.removeClass('hidden-panel');
//
// 			if (coursesOpen.length !== 0) {
// 				$('.enabled-checkout').each(function( index ) {
// 					$(this).show();
// 				});
// 				$('.disabled-checkout').each(function( index ) {
// 					$(this).hide();
// 				});
// 			}
//
// 			counterOpen.html(coursesOpen.length)
//
// 			var course_query = '';
// 			coursesOpen.forEach(function (item, index) {
// 				course_query += 'courses[]=' + item;
//
// 				if (index !== coursesOpen.length) {
// 					course_query += '&';
// 				}
// 			});
//
// 			$.ajax({
// 				method: "GET",
// 				url: "/wp-content/themes/tikvahcenter/2019/load-cart.php?" + course_query
// 			})
// 				.done(function( html ) {
// 					console.log('success!');
// 					console.log('this is the html: ' + html);
// 					panelbodyOpen.append(html);
// 				});
// 		}
//
// 		if (utmOpen['utm_source']) {
// 			setCookie("utm_source", utmOpen['utm_source'], 1);
// 		}
// 		if (utmOpen['utm_medium']) {
// 			setCookie("utm_medium", utmOpen['utm_medium'], 1);
// 		}
// 		if (utmOpen['utm_campaign']) {
// 			setCookie("utm_campaign", utmOpen['utm_campaign'], 1);
// 		}
// 		if (utmOpen['utm_content']) {
// 			setCookie("utm_content", utmOpen['utm_content'], 1);
// 		}
// 	}
//
// 	$('#show-all-bios').on('click', function () {
// 		$('#bios-accordion .panel-collapse').collapse('show');
// 	});
//
// 	$('#hide-all-bios').on('click', function () {
// 		$('#bios-accordion .panel-collapse').collapse('hide');
// 	});
//
// 	$(document).scroll(function() {
// 		var y = $(this).scrollTop();
// 		if (y > 600) {
// 			$('#bios-back-to-top').fadeIn();
// 		} else {
// 			$('#bios-back-to-top').fadeOut();
// 		}
// 	});
//
// 	// Modal JS
// 	$('[data-modal-trigger]').on('click', function(e){
// 		e.preventDefault();
//
// 		console.log('vimeo refresh A');
// 		setTimeout(function(){ window.__vimeoRefresh(); }, 5000);
//
// 		var modalName = $(this).attr('data-modal-trigger');
// 		var $modal = $('[data-modal=' + modalName + ']');
// 		var display = $modal.css('display') == 'none' ? false : true;
//
// 		// Check if youtube video
// 		var ytId = $(this).attr('data-ytid');
// 		if (ytId) {
// 			var ytTemplate = '<div class="video-wrapper">';
// 			ytTemplate += '<iframe src="https://www.youtube.com/embed/' + ytId + '?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>'
// 			ytTemplate += '</div>';
//
// 			$modal.children('.modal-content').append(ytTemplate);
// 		}
//
// 		// Check if regular mp4 video
// 		var video = $(this).attr('data-video');
// 		if (video) {
// 			var videoUrl = window.location.origin + '/wp-content/themes/tikvahcenter/assets/images/daniel-deronda/videos/' + video;
//
// 			var videoTemplate = '<video class="video-js vjs-default-skin" id="video-player">';
// 			videoTemplate += ' <source src="' + videoUrl + '" type="video/mp4">';
// 			videoTemplate += '</video>';
//
// 			$modal.children('.modal-content').append(videoTemplate);
//
// 			videojs('video-player', { "controls": true, "autoplay": true, "preload": "auto" }, function(){
// 				// Player (this) is initialized and ready.
// 			});
// 		}
//
// 		// Check if Vimeo video
// 		var vimeo = $(this).attr('data-vimeo');
// 		if (vimeo) {
// 			console.log('Vimeo: ' + vimeo);
//
// 			var vimeoTemplate = '<div class="video-wrapper"><div id="vimeo-player"></div></div>';
//
// 			$modal.children('.modal-content').append(vimeoTemplate);
//
// 			// console.log(vimeoTemplate);
// 			// console.log($modal);
//
// 			var vimeoPlayer = new Vimeo.Player('vimeo-player', {
// 				id: vimeo,
// 				autoplay: true,
// 				byline: false,
// 				portrait: false,
// 				title: false,
// 				color: ''
// 			});
// 			console.log('vimeo refresh B');
// 			//window.__vimeoRefresh();
// 		}
//
// 		// Check if MP3
// 		var audio = $(this).attr('data-audio');
// 		if (audio) {
// 			var audioUrl = audio;
//
// 			var audioTemplate = '<audio id="audio-player" controls>';
// 			audioTemplate += '<source src="' + audioUrl + '" type="audio/mpeg">';
// 			audioTemplate += '</audio>';
//
// 			$modal.children('.modal-content').append(audioTemplate);
// 			$('#audio-player').get(0).play();
// 		}
//
//
//
// 		if ( !display ) {
// 			$modal.css({'display': 'block'});
//
// 			// Close modal if clicked on overlay
// 			window.onclick = function(e) {
// 				console.log('vimeo refresh');
// 				//window.__vimeoRefresh();
// 				if ( $(e.target).hasClass('course-modal') ) {
//
// 					if ( $('#video-player').length === 1 ) {
// 						videojs('video-player').dispose();
// 					}
//
// 					if ( $('#vimeo-player').length === 1 ) {
// 						$('#vimeo-player').remove();
// 					}
//
// 					if ( $('#audio-player').length === 1 ) {
// 						$('#audio-player').get(0).pause();
// 						$('#audio-player').remove();
// 					}
//
// 					$modal.find('.video-wrapper').remove();
// 					$modal.css({'display': 'none'});
// 				}
// 			}
//
// 		} else {
// 			if ( $('#video-player').length === 1  ) {
// 				videojs('video-player').dispose();
// 			}
//
// 			if ( $('#vimeo-player').length === 1 ) {
// 				$('#vimeo-player').remove();
// 			}
//
// 			if ( $('#audio-player').length === 1 ) {
// 				$('#audio-player').get(0).pause();
// 				$('#audio-player').remove();
// 			}
//
// 			$modal.find('.video-wrapper').remove();
// 			$modal.css({'display': 'none'});
// 		}
// 	});
//
//
// 	// Home Carousel
//     //===========================================
//     if ( $('body').hasClass('home') ) {
//
//     	// Init main carousel
// 		$('#header-carousel').slick({
// 			arrows: false,
// 			asNavFor: '#carousel-background',
// 			responsive: [
// 			    {
// 			      breakpoint: 768,
// 			      settings: {
// 			        adaptiveHeight: true
// 			      }
// 			    }
// 			  ]
// 		});
//
// 		$('#carousel-background').slick({
// 			slidesToShow: 1,
// 			slidesToScroll: 1,
// 			arrows: false,
// 			fade: true,
// 			asNavFor: '#header-carousel'
// 		});
//
// 		// Init arousel nav
// 		$('#carousel-nav').slick({
// 			slidesToShow: 4,
// 			slidesToScroll: 1,
// 			arrows: false,
// 			infinite: true,
// 			focusOnSelect: false
// 		});
//
// 		// Sync nav to carousel
// 		$('#header-carousel').on('afterChange', function(event, slick, currentSlide) {
// 			if ( $('#carousel-nav .slick-slide').eq(currentSlide).hasClass('slick-current') ) return;
// 			$('#carousel-nav .slick-slide').removeClass('slick-current');
// 			$('#carousel-nav .slick-slide').eq(currentSlide).addClass('slick-current');
// 		});
//
// 		// Sync carousel to nav
// 		$('#carousel-nav .preview-item').on('click', function(e) {
// 			e.preventDefault();
// 			$('#carousel-nav .slick-slide').removeClass('slick-current');
// 			$(this).addClass('slick-current');
// 			$('#header-carousel').slick('slickGoTo', $(this).data('slickIndex'));
// 		});
//
// 		// Podcast slide play
// 		$('.podcast-slide .play-btn').on('click', function(e) {
// 			e.preventDefault();
// 			var $slide = $(this).parents('.carousel-slide');
// 			var $parent = $(this).parents('.slide-content');
// 			var $player = $parent.find('.mejs-audio');
//
// 			// Remove play button
// 			$parent.addClass('player-started');
//
// 			// Show player
// 			$player.fadeIn(300).find('audio').get(0).play();
//
// 			// Set new height for slide to accommodate player
// 			if ( window.innerWidth < 768) {
// 				var height = $slide.height();
// 				$('#header-carousel .slick-list').height( height );
// 			}
// 		});
//
// 		// Video slide play
// 		$('.video-slide .play-btn').on('click', function(e) {
// 			e.preventDefault();
// 			var videoId = $(this).data('video-id');
// 			var $slide = $(this).parents('.carousel-slide');
// 			var $content = $slide.find('.slide-content');
// 			var $embedWrapper = $slide.find('.embed-responsive');
// 			var $player = $slide.find('.embed-responsive-item');
// 			var $spinner = $('<i class="fas fa-spinner fa-pulse"></i>');
//
// 			// Remove play button and add loader
// 			$slide.append( $spinner );
// 			$(this).fadeOut(150);
// 			$spinner.fadeIn(300);
//
// 			// Remove slide content on desktop
// 			if ( window.innerWidth >= 768) {
// 				$content.fadeOut(150);
// 			}
//
// 			// Load video
// 			$player.attr('src', 'https://www.youtube.com/embed/' + videoId + '?rel=0&autoplay=1');
// 			$player.load(function(){
// 				$slide.addClass('player-started');
// 				$(this).css({'opacity': 1});
// 				$spinner.fadeOut(300);
// 	        });
// 		});
//     }
//
//
// 	// Navbar Search Toggle
// 	//===========================================
// 	$('#navbar-search .search-toggle').on('click', function() {
// 		if ( !$('.secondary-menu').hasClass('show-search') ) {
// 			$(this).attr('aria-expanded', 'true');
// 			$('.secondary-menu').addClass('show-search');
// 			$('.secondary-menu .nav-link').attr('tabindex', '-1');
// 			$('#navbar-search .form-control').focus();
// 		} else {
// 			$(this).attr('aria-expanded', 'false');
// 			$('.secondary-menu').removeClass('show-search');
// 			$('.secondary-menu .nav-link').attr('tabindex', '0');
// 		}
// 	});
//
//
// 	// Submenu Mobile Dropdown Toggle
//     //===========================================
// 	$('.submenu-toggle').on('click', function() {
// 		var $toggle = $(this);
// 		var $subpages = $toggle.parent('.subpage-nav-collapsible');
// 		var $wrapper = $subpages.children('.toggle-wrapper');
//
// 		if ( $subpages.hasClass('opening') || $subpages.hasClass('closing') ) {
// 			return;
// 		}
//
// 		if ( $subpages.hasClass('closed') ) {
// 			$subpages.addClass('opening').removeClass('closed');
// 		} else {
// 			$subpages.addClass('closing').removeClass('opened');
// 		}
//
// 		$wrapper.animate({
// 			height: "toggle"
// 		}, 400, function() {
// 			if ( $subpages.hasClass('opening') ) {
// 				$subpages.addClass('opened').removeClass('opening');
// 				$toggle.attr('aria-expanded', 'true');
// 			} else {
// 				$subpages.addClass('closed').removeClass('closing');
// 				$toggle.attr('aria-expanded', 'false');
// 			}
// 		});
// 	});
//
//
// 	// Teaser Audio Player
// 	//===========================================
// 	$('.podcast-player-wrapper .play-btn').on('click', function(e) {
// 		e.preventDefault();
// 		var $parent = $(this).parents('.podcast-player-wrapper');
// 		var $text = $parent.children('.description');
// 		var $player = $parent.children('.mejs-audio');
// 		$text.fadeOut(300);
// 		$player.fadeIn(300).find('audio').get(0).play();
// 	});
//
//
// 	// Featured Audio Player
// 	//===========================================
// 	$('.podcast-player .play-btn').on('click', function(e) {
// 		e.preventDefault();
// 		var $parent = $(this).parents('.podcast-player');
// 		var $player = $parent.find('.mejs-audio');
// 		$player.fadeIn(300).find('audio').get(0).play();
// 	});
//
//
// 	// Program Preview Video Player
//     //===========================================
//     $('.featured-video .play-btn').on('click', function(e) {
// 		e.preventDefault();
//
// 		var videoId = $(this).data('video-id');
// 		var $parent = $(this).parents('.featured-video');
// 		var $embedWrapper = $parent.find('.embed-responsive');
// 		var $player = $parent.find('.embed-responsive-item');
// 		var $spinner = $('<i class="fas fa-spinner fa-pulse"></i>');
//
// 		// Remove play button and add loader
// 		$embedWrapper.append( $spinner );
// 		$(this).fadeOut(150);
// 		$spinner.fadeIn(300);
//
//
// 		// // Load video
// 		$player.attr('src', 'https://www.youtube.com/embed/' + videoId + '?rel=0&autoplay=1');
// 		$player.load(function(){
// 			$(this).css({'opacity': 1});
// 			$spinner.fadeOut(300);
//         });
// 	});
//
// 	// Highlights Preview Video Player
// 	//===========================================
// 	$('.video-section .play-btn').on('click', function(e) {
// 		e.preventDefault();
//
// 		var videoId = $(this).data('video-id');
// 		var starttime = $(this).data('starttime');
// 		var endtime = $(this).data('endtime');
// 		var $parent = $('.featured-video');
// 		var $embedWrapper = $parent.find('.embed-responsive');
// 		var $player = $parent.find('.embed-responsive-item');
// 		var $spinner
//
// 		$('html, body').animate({ scrollTop: 150 }, 'fast');
//
// 		// Remove play button and add loader
// 		if ($('.fa-spinner').length) {
// 			$spinner = $('.fas .fa-spinner .fa-pulse');
// 		} else {
// 			$spinner = $('<i class="fas fa-spinner fa-pulse"></i>');
// 			$embedWrapper.append( $spinner );
// 		}
// 		$('.featured-video .play-btn').fadeOut(150);
// 		$spinner.fadeIn(300);
//
//
// 		// // Load video
// 		$player.attr('src', 'https://www.youtube.com/embed/' + videoId + '?start=' + starttime + '&end=' + endtime + '&rel=0&autoplay=1');
// 		$player.load(function(){
// 			$(this).css({'opacity': 1});
// 			$spinner.fadeOut(300);
// 		});
// 	});
//
//     const addVideoLibraryPlayButtonEvent = () => {
//         $('.video-library .play-btn').on('click', function(e) {
//             e.preventDefault();
//
//             var videoId = $(this).data('video-id');
//             var starttime = $(this).data('starttime');
//             var endtime = $(this).data('endtime');
//             var $parent = $(this).parent();
//             var $embedWrapper = $parent.find('.embed-responsive-item');
//             var $player = $parent.find('.embed-responsive-item');
//             var $spinner
//
//             $spinner = $('<i class="fas fa-spinner fa-pulse"></i>');
//             $parent.append( $spinner );
//             $(this).fadeOut(150);
//             $spinner.fadeIn(300);
//
//             $player.attr('src', 'https://www.youtube.com/embed/' + videoId + '?start=' + starttime + '&end=' + endtime + '&rel=0&autoplay=1');
//             $player.load(function(){
//                 $(this).css({'opacity': 1});
//                 $spinner.fadeOut(300);
//             });
//         });
//     };
//
//     addVideoLibraryPlayButtonEvent();
//
//     const videoLibrarySearch = (clearContent = false) => {
//         const postId = parseInt(document.querySelector('.video-library').getAttribute('data-page-id'));
//         const page = (parseInt(document.querySelector('.video-library').getAttribute('data-page')) ?? 1);
//         const firstLoad = (parseInt(document.querySelector('.video-library').getAttribute('data-first-load')) ?? 0);
//         const search = document.querySelector('#video-search-value').value;
//         let orderBy = null;
//         let order = null;
//         if (document.querySelector('.video-library #video-select-sort')) {
//             orderBy = 'date';
//             order = document.querySelector('.video-library #video-select-sort').value;
//         }
//
//         $.ajax({
//             url: '/wp-json/acf/v1/video-library-filter/' + postId,
//             method: 'GET',
//             data: {
//                 page: page,
//                 search: search,
//                 orderBy: orderBy,
//                 order: order,
//                 firstLoad: firstLoad,
//             },
//             success: (response) => {
//                 let content = '';
//                 if ((search.length == 0 || page > 1) && !clearContent) {
//                     content = document.querySelector('.video-list').innerHTML.trim();
//                 }
//                 $('.video-list .container.video-row').remove();
//                 response.videos.forEach(function(video) {
//                     content += '<div class="container video-row">' +
//                         '<div class="video-wrapper">' +
//                             '<div class="embed-responsive-video" style="background-image:url(https://img.youtube.com/vi/' + video.youtube_video_id + '/0.jpg)">' +
//                                 '<iframe class="embed-responsive-item" src="" allowfullscreen></iframe>' +
//                                 '<a class="play-btn" href="#" data-video-id="' + video.youtube_video_id + '">' +
//                                     '<span class="sr-only">Play video</span>' +
//                                 '</a>' +
//                             '</div>' +
//                         '</div>' +
//                         '<div class="text-wrapper">' +
//                             '<h2>' + video.heading + '</h2>' +
//                             '<p>' + video.subheading + '</p>' +
//                         '</div>' +
//                     '</div>'
//                 });
//
//                 if (content.length === 0) {
//                     content = '<div class="container mb-4">' +
//                         '<div class="row text-center">' +
//                             '<h2 class="w-100">No videos found</h2>' +
//                         '</div>' +
//                     '</div>'
//                 }
//
//                 $('.video-list').html(content);
//
//                 if (response.current_page >= response.max_pages) {
//                     $('.video-library .load-more-row').addClass('d-none');
//                 } else {
//                     $('.video-library .load-more-row').removeClass('d-none');
//                 }
//                 document.querySelector('.video-library').setAttribute('data-page', page + 1)
//                 if (clearContent) {
//                     addVideoLibraryPlayButtonEvent();
//                 }
//             },
//             error: function(xhr, status, error) {
//                 console.log(error);
//             }
//         });
//     };
//
//     const videoLibraryLoadMoreButton = document.querySelector('.video-library .load-more-row button');
//     if (videoLibraryLoadMoreButton) {
//         $(videoLibraryLoadMoreButton).on('click', function(e) {
//             videoLibrarySearch();
//         });
//     }
//
//     const videoLibrarySearchButton = document.querySelector('.video-library #video-search-button');
//     if (videoLibrarySearchButton) {
//         $(videoLibrarySearchButton).on('click', function(e) {
//             document.querySelector('.video-library').setAttribute('data-page', 1)
//             document.querySelector('.video-library').setAttribute('data-first-load', 0)
//             videoLibrarySearch(true);
//         });
//     }
//
//     const videoLibraryDateSelector = document.querySelector('.video-library #video-select-sort');
//     if (videoLibraryDateSelector) {
//         $(videoLibraryDateSelector).on('change', function(e) {
//             document.querySelector('.video-library').setAttribute('data-page', 1)
//             document.querySelector('.video-library').setAttribute('data-first-load', 0)
//             videoLibrarySearch(true);
//         });
//     }
//
//     const videoLibraryInputField = document.querySelector('.video-library #video-search-value');
//     if (videoLibraryInputField) {
//         var videoLibraryInputFieldDebounceTimer;
//         videoLibraryInputField.addEventListener("input", function() {
//             clearTimeout(videoLibraryInputFieldDebounceTimer);
//             videoLibraryInputFieldDebounceTimer = setTimeout(() => {
//                 document.querySelector('.video-library').setAttribute('data-page', 1)
//                 document.querySelector('.video-library').setAttribute('data-first-load', 0)
//                 videoLibrarySearch(true)
//             }, 750);
//         });
//     }
//
// 	// Jump Nav
//     //===========================================
//     $('.jump-nav a').on('click', function(e) {
// 		e.preventDefault();
// 		var section = '#' + $(this).get(0).hash.substr(1);
//
// 		$('html, body').animate({
// 			scrollTop: $(section).offset().top
// 		}, 750);
// 	});
//
//
//     // AJAX Load Posts
// 	//===========================================
// 	$('#load-more').on('click', function(e) {
// 		e.preventDefault();
// 		var $read_more = $(this);
// 		var $listingWrap = $('.ajax-feed');
// 		var $spinner = $('#arrow-spinner');
//
// 		$read_more.hide();
// 		$spinner.show();
//
// 		$(this).attr('data-paged', parseInt($(this).attr('data-paged'))+1);
// 		$.ajax({
// 			method: "GET",
// 			url: "/wp-content/themes/sapling/load-posts.php?"+$(this).attr('data-query')+'&paged='+$(this).attr('data-paged')
// 		})
// 			.done(function( html ) {
// 				$spinner.hide();
// 				$listingWrap.append(html);
// 				if (html == '<div class="end-of-feed">No Results Found</div>') {
// 					$read_more.hide();
// 					$('.no-results').show();
// 				} else if ($('.end-of-feed').length) {
// 					$read_more.hide();
// 					$('.no-results').hide();
// 				} else {
// 					$read_more.css('display', 'inline-block');
// 					$('.no-results').hide();
// 				}
// 			});
//
// 	});
//
// 	$('#podcast-feed-filters').on('submit', function(e) {
// 		e.preventDefault();
// 		var $read_more = $('#load-more');
// 		var $listingWrap = $('.ajax-feed');
// 		var $authorlist = [];
// 		var $authorNameList = [];
// 		var $catlist = [];
// 		var $keyword;
// 		var $spinner = $('#arrow-spinner');
//
// 		$read_more.hide();
// 		$spinner.show();
//
// 		if ($('#authors').val() !== '0') {
// 			$authorlist.push($('#authors').val());
// 			var el = document.getElementById('authors');
// 			var text = el.options[el.selectedIndex].innerHTML;
// 			$authorNameList.push(text);
// 		}
//
// 		if ($('#topics').val() !== '0') {
// 			$catlist.push($('#topics').val());
// 		}
// 		if ($('#search-filter').val() !== '') {
// 			$keyword = $('#search-filter').val();
// 		}
// 		var defaults = decodeURIComponent($read_more.attr('data-default-query'));
//
// 		$read_more.attr('data-paged', 1);
// 		$read_more.attr('data-query', $read_more.attr('data-default-query')+'&'+build_filter_query({
// 			'authors': $authorlist.length ? $authorlist : false,
// 			'authorNames': $authorNameList.length ? $authorNameList : false,
// 			'categories': $catlist.length ? $catlist : false,
// 			'posts_per_page': 10,
// 			's' : $keyword,
// 			//'show_date': ($('body.archive, body.search, body.category').length) ? 1 : 0,
// 			//'no_crop': ($('body.term-books, body.term-public-lands-reports, body.term-policy-series').length) ? 1 : 0
// 		}));
// 		window.console.log($read_more.attr('data-query'));
// 		$.ajax({
// 			method: "GET",
// 			url: "/wp-content/themes/sapling/load-posts.php?"+$read_more.attr('data-query')+'&paged='+$read_more.attr('data-paged')
// 		})
// 			.done(function( html ) {
// 				$spinner.hide();
// 				$listingWrap.empty();
// 				$listingWrap.append(html);
// 				if (html == '<div class="end-of-feed">No Results Found</div>') {
// 					$read_more.hide();
// 					$('.no-results').show();
// 				} else if ($('.end-of-feed').length) {
// 					$read_more.hide();
// 					$('.no-results').hide();
// 				} else {
// 					$read_more.css('display', 'inline-block');
// 					$('.no-results').hide();
// 				}
// 			});
// 	});
//
// 	$('#archive-feed-filters').on('submit', function(e) {
// 		e.preventDefault();
// 		var $read_more = $('#load-more');
// 		var $listingWrap = $('.ajax-feed');
// 		var $authorlist = [];
// 		var $authorNameList = [];
// 		var $catlist = [];
// 		var $keyword;
// 		var $spinner = $('#arrow-spinner');
//
// 		$read_more.hide();
// 		$spinner.show();
//
// 		if ($('#authors').val() !== '0') {
// 			$authorlist.push($('#authors').val());
// 			var el = document.getElementById('authors');
// 			var text = el.options[el.selectedIndex].innerHTML;
// 			$authorNameList.push(text);
// 		}
// 		if ($('#topics').val() !== '0') {
// 			$catlist.push($('#topics').val());
// 		}
// 		console.log($('#search-filter').val());
// 		if ($('#search-filter').val() !== '') {
// 			$keyword = $('#search-filter').val();
// 		}
// 		var defaults = decodeURIComponent($read_more.attr('data-default-query'));
//
// 		$read_more.attr('data-paged', 1);
// 		$read_more.attr('data-query', $read_more.attr('data-default-query')+'&'+build_filter_query({
// 			'authors': $authorlist.length ? $authorlist : false,
// 			'authorNames': $authorNameList.length ? $authorNameList : false,
// 			'categories': $catlist.length ? $catlist : false,
// 			'posts_per_page': 10,
// 			's' : $keyword,
// 			//'show_date': ($('body.archive, body.search, body.category').length) ? 1 : 0,
// 			//'no_crop': ($('body.term-books, body.term-public-lands-reports, body.term-policy-series').length) ? 1 : 0
// 		}));
// 		window.console.log($read_more.attr('data-query'));
// 		$.ajax({
// 			method: "GET",
// 			url: "/wp-content/themes/sapling/load-posts.php?"+$read_more.attr('data-query')+'&paged='+$read_more.attr('data-paged')
// 		})
// 			.done(function( html ) {
// 				$spinner.hide();
// 				$listingWrap.empty();
// 				$listingWrap.append(html);
// 				if (html == '<div class="end-of-feed">No Results Found</div>') {
// 					$read_more.hide();
// 					$('.no-results').show();
// 				} else if ($('.end-of-feed').length) {
// 					$read_more.hide();
// 					$('.no-results').hide();
// 				} else {
// 					$read_more.css('display', 'inline-block');
// 					$('.no-results').hide();
// 				}
// 			});
// 	});
//
// 	$('#events-feed-filters').on('submit', function(e) {
// 		e.preventDefault();
// 		var $read_more = $('#load-more');
// 		var $listingWrap = $('.ajax-feed');
// 		var $authorlist = [];
// 		var $catlist = [];
// 		var $keyword;
// 		var $spinner = $('#arrow-spinner');
//
// 		$read_more.hide();
// 		$spinner.show();
//
// 		if ($('#authors').val() !== '0') {
// 			$authorlist.push($('#authors').val());
// 		}
// 		if ($('#topics').val() !== '0') {
// 			$catlist.push($('#topics').val());
// 		}
// 		console.log($('#search-filter').val());
// 		if ($('#search-filter').val() !== '') {
// 			$keyword = $('#search-filter').val();
// 		}
// 		var defaults = decodeURIComponent($read_more.attr('data-default-query'));
//
// 		$read_more.attr('data-paged', 1);
// 		$read_more.attr('data-query', $read_more.attr('data-default-query')+'&'+build_filter_query({
// 			'past_only': true,
// 			'authors': $authorlist.length ? $authorlist : false,
// 			'categories': $catlist.length ? $catlist : false,
// 			'posts_per_page': 10,
// 			's' : $keyword,
// 			//'show_date': ($('body.archive, body.search, body.category').length) ? 1 : 0,
// 			//'no_crop': ($('body.term-books, body.term-public-lands-reports, body.term-policy-series').length) ? 1 : 0
// 		}));
// 		window.console.log($read_more.attr('data-query'));
// 		$.ajax({
// 			method: "GET",
// 			url: "/wp-content/themes/sapling/load-posts.php?"+$read_more.attr('data-query')+'&paged='+$read_more.attr('data-paged')
// 		})
// 			.done(function( html ) {
// 				$spinner.hide();
// 				$listingWrap.empty();
// 				$listingWrap.append(html);
// 				if (html == '<div class="end-of-feed">No Results Found</div>') {
// 					$read_more.hide();
// 					$('.no-results').show();
// 				} else if ($('.end-of-feed').length) {
// 					$read_more.hide();
// 					$('.no-results').hide();
// 				} else {
// 					$read_more.css('display', 'inline-block');
// 					$('.no-results').hide();
// 				}
// 			});
// 	});
//
// 	function build_filter_query(args) {
// 		var query = [];
// 		var today_date = new Date();
// 		today_date.setHours(0, 0, 0, 0);
// 		var today = formatDate(today_date, 'yyyyMMdd');
// 		console.log(today);
// 		var keys = [];
//
// 		if (args['post_type']) {
// 			query['post_type'] = args['post_type'];
// 		}
// 		if (args['past_only'] && args['authors'] && args['authors'].length) {
// 			query['meta_query'] = query['meta_query'] || [];
// 			var peoplequery = [];
// 			var authorquery = [];
// 			var peopleauthorquery = [];
// 			var datequery = [];
// 			peoplequery.push({
// 				'key': 'people',
// 				'value': args['authors'][0],
// 				'compare': 'LIKE'
// 			});
// 			if (args['authorNames']) {
// 				authorquery.push({
// 					'key': 'author',
// 					'value': args['authorNames'][0],
// 					'compare': 'LIKE'
// 				});
// 			}
// 			peopleauthorquery.push({
// 				'relation': 'OR',
// 				peoplequery,
// 				authorquery
// 			});
// 			datequery.push({
// 				'key'	 	: 'date',
// 				'compare'	: '<',
// 				'value'		: today,
// 			});
// 			query['meta_query'].push({
// 				'relation': 'AND',
// 				peopleauthorquery,
// 				datequery
// 			});
// 			keys.push('auth='+args['authors'][0]);
// 		} else if (args['past_only']) {
// 			query['meta_query'] = query['meta_query'] || [];
// 			query['meta_query'].push({
// 				'key'	 	: 'date',
// 				'compare'	: '<',
// 				'value'		: today,
// 			});
// 		} else if (args['authors'] && args['authors'].length) {
// 			query['meta_query'] = query['meta_query'] || [];
// 			var peoplequery = [];
// 			var authorquery = [];
// 			peoplequery.push({
// 				'key': 'people',
// 				'value': args['authors'][0],
// 				'compare': 'LIKE'
// 			});
// 			authorquery.push({
// 				'key': 'author',
// 				'value': args['authorNames'][0],
// 				'compare': 'LIKE'
// 			});
// 			query['meta_query'].push({
// 				'relation': 'OR',
// 				peoplequery,
// 				authorquery
// 			});
// 			keys.push('auth='+args['authors'][0]);
// 		}
// 		if (args['posts_per_page']) {
// 			query['posts_per_page'] = args['posts_per_page'];
// 		}
// 		if (args['s']) {
// 			query['s'] = args['s'];
// 			keys.push('key='+args['s']);
// 		}
// 		if (args['categories'] && args['categories'].length) {
// 			query['tax_query'] = query['tax_query'] || [];
// 			query['tax_query'].push({
// 				'taxonomy': 'category',
// 				'field': 'slug',
// 				'terms': args['categories']
// 			});
// 			keys.push('topic='+args['categories'][0]);
// 		}
// 		window.console.log(keys);
// 		window.console.log(args);
// 		window.console.log(query);
//
// 		if (history.pushState) {
// 			var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + keys.join('&');
// 			window.history.pushState({path:newurl},'',newurl);
// 		}
// 		return http_get_serialized(query);
// 	}
//
//
// 	function http_get_serialized(obj, prefix) {
// 		var str = [], p;
// 		for(p in obj) {
// 			if (obj.hasOwnProperty(p)) {
// 				var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
// 				str.push((v !== null && typeof v === "object") ?
// 					http_get_serialized(v, k) :
// 					encodeURIComponent(k) + "=" + encodeURIComponent(v));
// 			}
// 		}
// 		return str.join("&");
// 	}
//
// 	function formatDate(date, format, utc) {
// 		var MMMM = ["\x00", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
// 		var MMM = ["\x01", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
// 		var dddd = ["\x02", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
// 		var ddd = ["\x03", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//
// 		function ii(i, len) {
// 			var s = i + "";
// 			len = len || 2;
// 			while (s.length < len) s = "0" + s;
// 			return s;
// 		}
//
// 		var y = utc ? date.getUTCFullYear() : date.getFullYear();
// 		format = format.replace(/(^|[^\\])yyyy+/g, "$1" + y);
// 		format = format.replace(/(^|[^\\])yy/g, "$1" + y.toString().substr(2, 2));
// 		format = format.replace(/(^|[^\\])y/g, "$1" + y);
//
// 		var M = (utc ? date.getUTCMonth() : date.getMonth()) + 1;
// 		format = format.replace(/(^|[^\\])MMMM+/g, "$1" + MMMM[0]);
// 		format = format.replace(/(^|[^\\])MMM/g, "$1" + MMM[0]);
// 		format = format.replace(/(^|[^\\])MM/g, "$1" + ii(M));
// 		format = format.replace(/(^|[^\\])M/g, "$1" + M);
//
// 		var d = utc ? date.getUTCDate() : date.getDate();
// 		format = format.replace(/(^|[^\\])dddd+/g, "$1" + dddd[0]);
// 		format = format.replace(/(^|[^\\])ddd/g, "$1" + ddd[0]);
// 		format = format.replace(/(^|[^\\])dd/g, "$1" + ii(d));
// 		format = format.replace(/(^|[^\\])d/g, "$1" + d);
//
// 		var H = utc ? date.getUTCHours() : date.getHours();
// 		format = format.replace(/(^|[^\\])HH+/g, "$1" + ii(H));
// 		format = format.replace(/(^|[^\\])H/g, "$1" + H);
//
// 		var h = H > 12 ? H - 12 : H == 0 ? 12 : H;
// 		format = format.replace(/(^|[^\\])hh+/g, "$1" + ii(h));
// 		format = format.replace(/(^|[^\\])h/g, "$1" + h);
//
// 		var m = utc ? date.getUTCMinutes() : date.getMinutes();
// 		format = format.replace(/(^|[^\\])mm+/g, "$1" + ii(m));
// 		format = format.replace(/(^|[^\\])m/g, "$1" + m);
//
// 		var s = utc ? date.getUTCSeconds() : date.getSeconds();
// 		format = format.replace(/(^|[^\\])ss+/g, "$1" + ii(s));
// 		format = format.replace(/(^|[^\\])s/g, "$1" + s);
//
// 		var f = utc ? date.getUTCMilliseconds() : date.getMilliseconds();
// 		format = format.replace(/(^|[^\\])fff+/g, "$1" + ii(f, 3));
// 		f = Math.round(f / 10);
// 		format = format.replace(/(^|[^\\])ff/g, "$1" + ii(f));
// 		f = Math.round(f / 10);
// 		format = format.replace(/(^|[^\\])f/g, "$1" + f);
//
// 		var T = H < 12 ? "AM" : "PM";
// 		format = format.replace(/(^|[^\\])TT+/g, "$1" + T);
// 		format = format.replace(/(^|[^\\])T/g, "$1" + T.charAt(0));
//
// 		var t = T.toLowerCase();
// 		format = format.replace(/(^|[^\\])tt+/g, "$1" + t);
// 		format = format.replace(/(^|[^\\])t/g, "$1" + t.charAt(0));
//
// 		var tz = -date.getTimezoneOffset();
// 		var K = utc || !tz ? "Z" : tz > 0 ? "+" : "-";
// 		if (!utc) {
// 			tz = Math.abs(tz);
// 			var tzHrs = Math.floor(tz / 60);
// 			var tzMin = tz % 60;
// 			K += ii(tzHrs) + ":" + ii(tzMin);
// 		}
// 		format = format.replace(/(^|[^\\])K/g, "$1" + K);
//
// 		var day = (utc ? date.getUTCDay() : date.getDay()) + 1;
// 		format = format.replace(new RegExp(dddd[0], "g"), dddd[day]);
// 		format = format.replace(new RegExp(ddd[0], "g"), ddd[day]);
//
// 		format = format.replace(new RegExp(MMMM[0], "g"), MMMM[M]);
// 		format = format.replace(new RegExp(MMM[0], "g"), MMM[M]);
//
// 		format = format.replace(/\\(.)/g, "$1");
//
// 		return format;
// 	}
//
// 	setTimeout(function() {
// 		if (window.location.hash){
// 			var hash = window.location.hash.substring(1);
// 			if (hash == "play"){
// 				$("#play-btn").trigger('click');
// 			}
// 		}
//
// 	}, 1000);
//
// 	// Highlights the current page of the fellowship in the navigation
// 	$(document).ready(function ($) {
// 		var url = window.location.href;
// 		var activePage = String( url ).split("#")[0];
// 		var numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'];
// 		$('.subpage a').each(function () {
// 			var linkPage = String( this.href ).split("#")[0];
// 			if ((activePage == linkPage) && (numbers.indexOf(String( this.href ).split("#")[1]) == '-1')) {
// 				$(this).closest("li").addClass("active");
// 			}
// 		});
// 	});
//
// 	$(document).ready(function ($) {
// 		let courses = document.cookie.split(';').filter(function(c) {
// 			if (c.trim().includes('true')) {
// 				return c.trim().indexOf('course') === 0;
// 			}
// 		}).map(function(c) {
// 			return "TOA" + c.trim().replace('course', '').replace('=true', '');
// 		});
//
// 		$('.enabled-checkout a').each(function(){
// 			console.log(courses.join(';'));
// 			this.href += courses.join(';') + ";";
// 		})
// 	});
//
// })(jQuery);
//
// const quoteCarousel = $ => {
// 	const $carousel = $( '#quote-carousel .carousel-wrapper' );
//
// 	const options = {
// 		slidesToShow: 1,
// 		fade: true,
// 		autoplay: true,
// 		autoplaySpeed: 5000,
// 		dots: true,
// 		arrows: false,
// 	};
//
// 	const initCarousel = () => {
// 		$carousel.slick( options );
// 	};
//
// 	return {
// 		init() {
// 			if ( ! $carousel.length ) {
// 				return;
// 			}
//
// 			this.bind();
// 		},
// 		bind() {
// 			initCarousel();
// 		}
// 	};
// };
//
// quoteCarousel( jQuery ).init();
//
//
//
// // RESOURCE CATEGORY TOPICS
// let postsLoaded = jQuery( "#load-more-button" ).data( "loaded" );
// // let postsLoaded = 0;
 let currentTopicSelected = null
 let currentContentTypeSelected = ''
// let currentSortOrder = 'DESC'
//
//
//
 jQuery(function ($) {
	$(document).ready(function () {
		const currentUrl = new URLSearchParams(window.location.search);
		 let preselectedTopic = currentUrl.get('topic');
		 $("#topic-select").val(preselectedTopic)
		//getResourceLibraryPosts(preselectedTopic, currentSortOrder, null, true, 0, currentContentTypeSelected)
	});
//
// 	if(postsLoaded < 4) {
// 		document.getElementById("load-more-button").style.display = "none"
// 	}
//
	/*$("#topic-select").change(function () {
		let selectedTopicValue = $(this).val()
		currentTopicSelected = selectedTopicValue
		//getResourceLibraryPosts(currentTopicSelected, currentSortOrder, null, false, 0, currentContentTypeSelected)
		updateQueryStringRefresh('topic', selectedTopicValue);
		console.log('topic select '+ selectedTopicValue);
	})*/
//
// 	$("#topic-select-sort").change(function () {
// 		let selectedSortValue = $(this).val()
// 		currentSortOrder = selectedSortValue
// 		getResourceLibraryPosts(currentTopicSelected, currentSortOrder, null, false, 0, currentContentTypeSelected)
// 	})
//
// 	$("#topic-select-content-type").change(function () {
// 		let selectedContentTypeValue = $(this).val()
// 		currentContentTypeSelected = selectedContentTypeValue
// 		getResourceLibraryPosts(currentTopicSelected, currentSortOrder, null, false, 0, currentContentTypeSelected)
// 		postsLoaded = 0
// 	})
//
// 	$("#load-more-button").click(function () {
// 		const currentUrl = new URLSearchParams(window.location.search);
// 		let preselectedTopic = currentUrl.get('topic');
// 		getResourceLibraryPosts(preselectedTopic, currentSortOrder, null, true, postsLoaded, currentContentTypeSelected)
// 	})
//
// 	$("#topic-search-button").click(function () {
// 		let searchValue = $("#topic-search-value").val();
// 		console.log(searchValue);
// 		postsLoaded = 0
// 		getResourceLibraryPosts(currentTopicSelected, currentSortOrder, searchValue, false, postsLoaded, currentContentTypeSelected)
// 	})
 })
//
function updateQueryString(key, value) {
	if (history.pushState) {
		let searchParams = new URLSearchParams(window.location.search);
		searchParams.set(key, value);
		let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
		window.history.pushState({path: newurl}, '', newurl);
	}
}

function updateQueryStringRefresh(key, value) {
	if (history.pushState) {
		let searchParams = new URLSearchParams(window.location.search);
		searchParams.set(key, value);
		let path = jQuery("#topic-select").data('permalink');
		let newurl = window.location.protocol + "//" + window.location.host + path + '?' + searchParams.toString() + '#topic-select';
		//window.history.pushState({path: newurl}, '', newurl);
		console.log(window.location.pathname);
		location.replace(newurl);
	}
}
//
function getResourceLibraryPosts(topic, sort, search, append, offset, content_type) {

	document.getElementById("library-resource-loading-bar").style.display = 'block'
	updateQueryString('topic', topic);

	let urlAttributes =
		'&topic=' + topic +
		'&offset=' + offset +
		'&sort=' + sort +
		'&content_type=' + content_type
	if (search) {
		urlAttributes += '&s=' + search
	}

	// jQuery.ajax({
	// 	type: "GET",
	// 	url: "/wp-admin/admin-ajax.php?action=resource_library_posts" + urlAttributes,
	// 	success: function (response) {
	// 		if (response.length < 4) {
	// 			document.getElementById("load-more-button").style.display = "none"
	// 		} else {
	// 			document.getElementById("load-more-button").style.display = "block"
	// 		}
	// 		if (!append) {
	// 			document.getElementById("resource-library-posts").innerHTML = ''
	// 		}
	// 		response.forEach(element => {
	// 			document.getElementById("resource-library-posts").innerHTML += resourceLibraryPostCard(element)
	// 		})
	//
	// 		postsLoaded = postsLoaded + response.length
	// 	},
	// 	error: function () {
	// 		document.getElementById("load-more-button").style.display = "none"
	// 		document.getElementById("resource-library-posts").innerHTML = '<div class="d-flex justify-content-center">No posts found.</div>'
	// 	}
	// })
	//document.getElementById("library-resource-loading-bar").style.display = 'none'
}
//
// function resourceLibraryPostCard(element) {
// 	return '<a href="' + element.permalink + '"><div id="topics-feed-card" class="card d-flex w-100 mb-3 overflow-hidden">' +
// 		'<div class="d-flex col-3 px-0 resource-library-image-block">' +
//         (element.featured == true ?
//             '<div class="featured-badge">' +
//                 '<i class="fas fa-star"></i>' +
//                 '<span class="text">Featured</span>' +
//             '</div>'
//         : '') +
// 		'<img src="' + element.image + '" class="card-thumbnail topic-image"/></div>' +
// 		'<div class="col-9 topic-feed-card-content">' +
// 		'<h2>' + element.title + '</h2>' +
// 		'<p class="text-primary">' + element.excerpt + '</p></div></div></a>'
// }
//
// /**
//  * Campus chapters JS
//  */
// jQuery(function ($) {
//     $(document).ready(function () {
//         const campusChapters = document.querySelector('section.campus-chapters');
//         if (campusChapters) {
//             campusChapters.querySelectorAll('article.content-card').forEach(function (card) {
//                 const openButton = card.querySelector('.card-button');
//                 if (openButton) {
//                     openButton.addEventListener('click', function () {
//                         campusChapters.querySelectorAll('.pop-up-box.visible').forEach(function (visibleBox) {
//                             visibleBox.classList.remove('visible')
//                         })
//
//                         const popUpBox = card.querySelector('.pop-up-box');
//                         if (popUpBox) {
//                             popUpBox.classList.add('visible');
//                         }
//                     })
//                 }
//
//                 const closeButton = card.querySelector('.pop-up-body .fa-times');
//                 if (closeButton) {
//                     closeButton.addEventListener('click', function () {
//                         const popUpBox = card.querySelector('.pop-up-box');
//                         if (popUpBox) {
//                             popUpBox.classList.remove('visible');
//                         }
//                     })
//                 }
//             });
//         }
//     })
// });


jQuery(function ($) {
	const $testimonials = $('#testimonials-wrapper');

	console.log('test');
	if ( $testimonials.length > 0 ) {
		$testimonials.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			infinite: true,
			focusOnSelect: false
		});
	}


});


const toaCart = $ => {
	const $counter = $('#course-counter');
	const $panelbody = $('#checkout-panel-body');
	const $panel = $('#checkout-panel');
	const $panelToggle = $(".checkout-panel-toggle")

	const setCookie = (cname, cvalue, exdays) => {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	const getCookie = (cname) => {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	const addCourse = ( post_id ) => {
		// User is selecting course
		setCookie("course" + post_id, 'true', 3);

		$('.enabled-checkout a').each(function () {
			this.href += "TOA" + post_id + ";";
		})

		if (getCookie("course" + post_id)) {

			var nesting = $(this);
			nesting.prop("disabled", true);
			$counter.html(parseFloat($counter.html()) + 1);

			var courses = getCookie("tikvah-online-cart");
			var course_array;

			if (courses) {
				courses = JSON.parse(courses);
				if (!courses.includes(post_id)) {
					courses.push(post_id);
				}
				course_array = courses;
				courses = JSON.stringify(courses);
				setCookie("tikvah-online-cart", courses, 3)
			} else {
				courses = [];
				courses.push(post_id);
				course_array = courses;
				courses = JSON.stringify(courses);
				setCookie("tikvah-online-cart", courses, 3)
				$panel.removeClass('hidden-panel');
			}

			$('.enabled-checkout').each(function (index) {
				$(this).show();
			});
			$('.disabled-checkout').each(function (index) {
				$(this).hide();
			});

			$panelToggle.removeClass('disabled');
			$panelToggle.prop('disabled', false);

			var course_query = '';
			course_array.forEach(function (item, index) {
				course_query += 'courses[]=' + item;

				if (index !== course_array.length) {
					course_query += '&';
				}
			});

			$.ajax({
				method: "GET",
				url: "/wp-content/themes/tikvahcenter/2019/load-cart.php?" + course_query
			})
				.done(function (html) {
					$panelbody.html(html);
					bindCartDelete();
				});
		} else {
			$('#adblock-modal').css('display', 'block');
		}
	}
	const removeCourse = ( post_id ) => {
		// User is removing this course
		var courses = getCookie("tikvah-online-cart");

		$('.enabled-checkout a').each(function () {
			var link = $(this).attr('href');
			var new_link = link.replace("TOA" + post_id + ";", "");
			$(this).attr('href', new_link)
		})

		let toa_id = "TOA" + post_id + ";";

		$('.enabled-checkout a').attr('href').replace(toa_id, "")

		if (courses) {
			courses = JSON.parse(courses);
			if (courses.includes(post_id)) {
				courses.splice(courses.indexOf(post_id), 1);
			}

			if (courses.length === 0) {
				noCourses();
			}

			courses = JSON.stringify(courses);
			setCookie("tikvah-online-cart", courses, 3)
		}

		$counter.html(parseFloat($counter.html()) - 1);

		$('#panel-course-' + post_id).remove();
		setCookie("course" + post_id, 'false', 3);
	}

	const noCourses = () => {
		$('.enabled-checkout').each(function (index) {
			$(this).hide();
		});
		$('.disabled-checkout').each(function (index) {
			$(this).show();
		});

		$panelToggle.addClass('disabled');
		$panelToggle.prop('disabled', true);

		if (!$panel.hasClass('collapsed')) {
			togglePanel();
		}
	}

	const togglePanel = () => {
		$panel.css('height', '');
		$panel.css('height', null);

		if ($panel.hasClass('collapsed')) {

			// Clone and hide element to get height for transition
			var clonedPanel = $panel.clone(true);
			clonedPanel.css('height', 'auto').css('display', 'none');
			$(document.body).append(clonedPanel);
			$panel.css('height', clonedPanel.height());
			clonedPanel.remove();

			$panel.removeClass('collapsed');
			$panelToggle.html('<span>Minimize</span> <i class="fas fa-angle-down"></i>')
		} else {
			$panel.addClass('collapsed');
			$panelToggle.html('<span>Maximize</span> <i class="fas fa-angle-up"></i>')
		}

		setTimeout(function(){
			$panel.css('height', '');
			$panel.css('height', null);
		}, 300);

	}

	const loadInitCourses = () => {
		let courses = getCookie("tikvah-online-cart");
		if (courses) {
			courses = JSON.parse(courses);

			$('.add-curriculum').each(function( index ) {
				var post_id = $(this).data('post-id');
				if (courses.includes(post_id)) {
					$(this).addClass('selected-course');
				}
			});

			$panel.removeClass('hidden-panel');

			if (courses.length !== 0) {
				$('.enabled-checkout').each(function( index ) {
					$(this).show();
				});
				$('.disabled-checkout').each(function( index ) {
					$(this).hide();
				});
			} else {
				noCourses();
			}

			$counter.html(courses.length)

			var course_query = '';
			courses.forEach(function (item, index) {
				course_query += 'courses[]=' + item;

				if (index !== courses.length) {
					course_query += '&';
				}

				$('.enabled-checkout a').each(function () {
					this.href += "TOA" + item + ";";
				})
			});

			$.ajax({
				method: "GET",
				url: "/wp-content/themes/tikvahcenter/2019/load-cart.php?" + course_query
			})
				.done(function( html ) {
					$panelbody.append(html);
					bindCartDelete();
				});
		}
	}

	const bindCartDelete = () => {
		$(".remove-course").click(function () {
			var post_id = $(this).data('post-id');
			removeCourse(post_id);
			let courseCard = $('[data-post-id="' + post_id + '"]');
			courseCard.removeClass('selected-course');
		});
	}

	return {
		init() {
			if ( ! $panel.length ) {
				return;
			}

			this.bind();
			loadInitCourses();
		},
		bind() {
			$(".add-curriculum").click(function () {
				var post_id = $(this).data('post-id');
				console.log(post_id);

				if ($(this).hasClass('selected-course')) {
					removeCourse(post_id);
					$(this).removeClass('selected-course');
				} else {
					addCourse(post_id);
					$(this).addClass('selected-course');
				}
			});

			$panelToggle.click(function(){
				togglePanel();
			});
		}
	};
};

toaCart( jQuery ).init();

document.addEventListener('DOMContentLoaded', function() {
  // Existing code...

  // Secondary Menu Sticky Behavior
  const secondaryMenu = document.querySelector('.secondary-menu');
  if (secondaryMenu) {
    const secondaryMenuTop = secondaryMenu.offsetTop;

    window.addEventListener('scroll', function() {
      if (window.pageYOffset > secondaryMenuTop) {
        secondaryMenu.classList.add('sticky');
        document.body.classList.add('has-sticky-secondary-menu');
      } else {
        secondaryMenu.classList.remove('sticky');
        document.body.classList.remove('has-sticky-secondary-menu');
      }
    });
  }

  // Rest of existing code...
});

const testimonialSlider = $ => {
	const $testimonials = $('.testimonial-slider');

    if ($('.testimonial-slider').length) {
        $('.testimonial-slider').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1800, // Match our fade duration (1.8s = 1800ms)
            slidesToShow: 1,
            cssEase: 'ease',
            fade: false,
            prevArrow: '<button type="button" class="slick-prev">Previous</button>',
            nextArrow: '<button type="button" class="slick-next">Next</button>',
            // Add these settings to prevent overflow
            variableWidth: false,
            centerMode: false
        });
    }
};

testimonialSlider( jQuery ).init();







